import { supabase } from "./supabase";

let packRequestInFlight = false;

const serverErrorCodes = new Set([
  "grant_not_found",
  "already_opened",
  "not_eligible",
  "unauthenticated",
  "invalid_input",
  "server_error",
]);

async function errorResult(error) {
  if (error?.context && typeof error.context.json === "function") {
    try {
      const body = await error.context.json();
      const code = serverErrorCodes.has(body?.error) ? body.error : "server_error";
      return {
        ok: false,
        code,
        ...(code === "not_eligible" && body?.next_eligible_at
          ? { nextEligibleAt: body.next_eligible_at }
          : {}),
      };
    } catch {
      return { ok: false, code: "server_error" };
    }
  }
  return { ok: false, code: "network_error" };
}

async function invokePack(body, mapSuccess) {
  if (packRequestInFlight) return { ok: false, code: "in_flight" };
  packRequestInFlight = true;
  try {
    let response;
    try {
      response = await supabase.functions.invoke("open-pack", { body });
    } catch {
      return { ok: false, code: "network_error" };
    }
    if (response.error) return errorResult(response.error);
    return mapSuccess(response.data);
  } catch {
    return { ok: false, code: "network_error" };
  } finally {
    packRequestInFlight = false;
  }
}

export function openGrantedPack(grantId) {
  return invokePack(
    { action: "open", grant_id: grantId },
    (data) => ({ ok: true, packId: data.pack_id, draws: data.draws }),
  );
}

export function claimStandardPack() {
  return invokePack(
    { action: "claim_standard" },
    (data) => ({
      ok: true,
      packId: data.pack_id,
      draws: data.draws,
      nextStandardAt: data.next_standard_at,
    }),
  );
}
